<template>
    <div class="page-content">
        <div class="page-body">
            <div class="invoice-content">
                <div class="invoice-margin mt-4" v-if="subscription">
                    <!-- <p class="current-membership-header"> {{ $t("invoice.yourCurrentMembership") }} </p> -->
                    <!-- <div class="current-membership mt-2">
                        <div class="subscription">
                            <p class="text-size-12"> {{ $t("invoice.yourSubscription") }} </p>
                            <p class="text-size-16" v-if="subscription.invoice"> <strong> {{ getSubscriptionDetails }} </strong> </p>
                            <p class="text-size-16" v-else> <strong> {{ $t("invoice.registeredUser") }} </strong> </p>
                        </div>
                        <div class="payment-method mt-2">
                            <p class="text-size-12"> {{ $t("invoice.paymentMethod") }} </p>
                            <p class="text-size-16"> {{ getPaymentMethod }} </p>
                        </div>
                        <div class="since mt-2">
                            <p class="text-size-12"> {{ $t("invoice.since") }} </p>
                            <p class="text-size-16"> {{ convertToDateFormat(subscription.start_date) || convertToDateFormat(user.created_at) }} </p>
                        </div>
                        <div class="next-invoice mt-2">
                            <p class="text-size-12"> {{ $t("invoice.yourNextInvoice") }} </p>
                            <p class="text-size-16"> {{ getNextPaymentDate }} </p>
                        </div>
                    </div> -->
                    <div class="invoice-table mt-3" v-if="subscription.invoice">
                        <!-- <div class="invoice-instruction">
                            <p class="text-size-12 ml-4 mt-2"> {{ $t("invoice.dueMembership") }} </p>
                        </div> -->
                        <div class="invoice-data">
                            <table>
                                <tr>
                                    <th>
                                        <p> {{ $t("invoice.invoiceDate") }} </p>
                                        <span>(DD.MM.YYYY)</span>
                                    </th>
                                    <th>
                                        {{ $t("invoice.description") }}
                                    </th>
                                    <th>
                                        {{ $t("invoice.period") }}
                                    </th>
                                    <th>
                                        {{ $t("invoice.amount") }}
                                    </th>
                                    <th>
                                        {{ $t("invoice.total") }}
                                    </th>
                                </tr>
                                <tr
                                    class="table-row"
                                    v-for="(invoice, index) in subscription.invoice"
                                    :key="invoice.id"
                                >
                                    <!-- first invoice is generated on the payment date -->
                                    <td v-if="index == 0">
                                        <BtnLink
                                            @click.native="printInvoiceDetails(invoice.key)"
                                            :label="convertToDateFormat(subscription.start_date)"
                                        />
                                    </td>
                                    <!-- Next generated on subscription date -->
                                    <td v-else>
                                        <BtnLink
                                            @click.native="printInvoiceDetails(invoice.key)"
                                            :label="convertToDateFormat(invoice.invoice_start_date)"
                                        />
                                    </td>
                                    <td>
                                        <!-- supporter membership -->
                                        {{ $t("package.premiumPackageName") }}
                                    </td>
                                    <td>
                                        {{ convertToDateFormat(invoice.invoice_start_date, false) }} - {{ convertToDateFormat(invoice.invoice_end_date, false) }}
                                    </td>
                                    <td>
                                        {{ parseFloat(invoice.membership.price).toFixed(2).replace('.',',')  }} {{ $t("invoice.eur") }} (+{{ parseFloat(invoice.membership.vat_amount).toFixed(2).replace('.',',')  }} {{ $t("invoice.eur") }} {{ $t("invoice.mwst") }})
                                    </td>
                                    <td>
                                        {{ (parseFloat(invoice.membership.price) + parseFloat(invoice.membership.vat_amount)).toFixed(2).replace('.',',') }} {{ $t("invoice.eur") }}
                                    </td>
                                </tr>
                            </table>
                        </div>
                        <p class="text-size-12 ml-4 mt-2"> {{ $t("invoice.invoiceCaution") }} </p>
                    </div>
                    <div class="text-size-12 mt-3 no-invoices" v-else>
                        {{ $t('membership.noInvoice') }}
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { HTTP } from '@/shared/http';
import { mapState } from 'vuex';
import moment from 'moment';
import { constants } from '@/shared/constant';

export default {
    name: 'Invoice',
    data() {
        return {
            subscription: null
        }
    },
    created() {
        const apiUrl = process.env.VUE_APP_API_URI_SEGMENT;
        const url = apiUrl + '/invoices/' +  this.user.id;
        HTTP.get(url)
        .then((response) => {
            this.subscription = response.data;
        })
        .catch((error) => {
            console.log(error);
        });
    },
    computed: {
        ...mapState({
            user: (state) => state.Login.user,
        }),
        getNextPaymentDate() {
            if(this.subscription && !this.subscription.cancel_status && this.subscription.invoice && this.subscription.invoice.length > 0) {
                let getLastInvoiceElement = this.subscription.invoice[this.subscription.invoice.length - 1];
                return this.convertToDateFormat(getLastInvoiceElement.invoice_end_date);
            }
            return this.$t('membership.notFound');
        },
        getPaymentMethod() {
            if(this.subscription && this.subscription.payment_method) {
                if(['mastercard', 'creditcard'].indexOf(this.subscription.payment_method.toLowerCase()) >= 0) {
                    return this.subscription.payment_method + " (" + this.subscription.details.cardNumber + ")";
                } else if(this.subscription.payment_method.toLowerCase() == 'paypal') {
                    return this.subscription.payment_method + " (" + this.user.email + ")";
                }
            }
            return this.$t('membership.notFound');
        },
        getPlanPrice() {
            return (constants.premiumUserPrice + constants.premiumUserVat);
        },
        getSubscriptionDetails() {
            return this.$t("invoice.subscriptionPrice", {"packageName": this.$t("package.premiumPackageName"), "price": this.getPlanPrice});
        }
    },
    methods: {
      /* redirect to invoice details */
      printInvoiceDetails(id){
        if(id) {
            const routeData = this.$router.resolve({
                path: `/membership/print-invoice-details/${id}`
            });
            window.open(routeData.href, "_blank");
        } else {
            alert("Key not found. Probably the old invoice, try other one.")
        }
      },
        convertToDateFormat(date, useDefault = true) {
            if(date) {
                if(useDefault == true) {
                    return moment(String(date)).format('DD.MM.YYYY')
                } else {
                    return moment(String(date)).format('DD.MM.YY')
                }
            }
        }
    }
};
</script>

<style lang="scss" scoped>
@import '@/styles/style.scss';

.page-content {
  -webkit-background-size: cover;
  -moz-background-size: cover;
  -o-background-size: cover;
  background-size: cover;
  background-color: $very-light-grey;
  min-height: 100vh;
  height: 100vh;
  overflow: hidden;
  display: flex;
  flex-direction: column;
}

.page-body {
  overflow: auto;
}

.invoice-content {
  display: flex;
  flex-direction: column;
}

.invoice-margin {
  margin-left: 0px !important;
  margin-right: 0px !important;
  padding-left: $mobile-margin-left;
  padding-right: $mobile-margin-left;
  color: $dark-grey;
}

.current-membership {
    max-width: 800px;
    color: $mid-grey;
    background-color: $white;
    border-radius: 9px;
    padding: 10px;
}

p {
    margin-bottom: 0px;
}

tr th, tr td {
    padding: 10px 23px;
    text-align: center;
    font-size: $small;
    border-bottom: solid 2px $mid-grey;
}

.current-membership-header {
    font-size: $standard;
    color: $dark-grey;
    font-weight: $medium-weight;
}

@media screen and (min-width: 481px) {
  .invoice-margin {
    margin-left: $desktop-margin-left !important;
    padding: 0px;
  }
}

</style>
